import axios from "axios";

//
//https://apiplants.amark.pro/
let urlAPI = "https://apiplants.amark.pro";
let axiosInstance = axios.create({
  baseURL: urlAPI,
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem("token")}`,
  },
});

export { urlAPI, axiosInstance };
